const IK = "https://ik.imagekit.io/mileseducation/hackathon";

export const HK_IMG = {
  milesLogo: `${IK}/miles_logo.webp`,
  cairaLogo: `${IK}/caira_logo.webp`,
  badgeAi101: `${IK}/badge_ai101.webp`,
  badgeL1: `${IK}/badge_l1.webp`,
  badgeL2: `${IK}/badge_l2.webp`,
  badgeL3: `${IK}/badge_l3.webp`,
  chrisComic: `${IK}/chris_comic.webp`,
  liPhoto: `${IK}/li_photo.webp`,
  mentorVarun: `${IK}/mentor_varun.webp`,
  mentorUttam: `${IK}/mentor_uttam.webp`,
  // Closing-section superhero (served from /public; move to ImageKit when convenient)
  finalSuperhero: "/hackathon/final_superhero.webp",
  aiLabsScreenshot: `${IK}/ailabs_screenshot.webp`,
  logoDeloitte: `${IK}/logo_deloitte.webp`,
  logoEy: `${IK}/logo_ey.webp`,
  logoKpmg: `${IK}/logo_kpmg.webp`,
  logoPwc: `${IK}/logo_pwc.webp`,
  logoAccenture: `${IK}/logo_accenture.webp`,
  logoAmazon: `${IK}/logo_amazon.webp`,
} as const;
